webpackJsonp([35783957827783],{

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	exports.__esModule = true;
	exports.trackEvent = trackEvent;
	function isGAEnabled() {
	  return ("production") === 'production' && typeof window.ga === 'function';
	}
	
	function ga() {
	  if (isGAEnabled()) {
	    var _window;
	
	    (_window = window).ga.apply(_window, arguments);
	  }
	}
	
	function trackEvent(eventCategory, eventAction, eventLabel) {
	  ga('send', {
	    hitType: 'event',
	    eventCategory: eventCategory,
	    eventAction: eventAction,
	    eventLabel: eventLabel
	  });
	}
	
	// use this global only when necessary (outside of the bundle, e.g. contact form)
	global.trackEvent = trackEvent;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ContactForm;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ContactForm(_ref) {
	  var location = _ref.location,
	      phone = _ref.phone,
	      email = _ref.email,
	      name = _ref.name,
	      id = _ref.id;
	
	  return _react2.default.createElement(
	    "div",
	    { className: "contact-container" },
	    _react2.default.createElement(
	      "form",
	      { id: id, name: name, method: "POST", "data-netlify": "true" },
	      _react2.default.createElement(
	        "div",
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { className: "input-field col s12" },
	          _react2.default.createElement("i", { className: "fa fa-user-o prefix", "aria-hidden": "true" }),
	          _react2.default.createElement("input", {
	            id: "contact-name",
	            type: "text",
	            className: "validate",
	            name: "first_name",
	            required: true
	          }),
	          _react2.default.createElement(
	            "label",
	            { htmlFor: "contact-name" },
	            "Name*"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "input-field col s12 m-t-1" },
	          _react2.default.createElement("i", { className: "fa fa-paper-plane-o prefix", "aria-hidden": "true" }),
	          _react2.default.createElement("input", {
	            id: "contact-email",
	            type: "email",
	            className: "validate",
	            name: "email",
	            required: true
	          }),
	          _react2.default.createElement(
	            "label",
	            { "data-error": "Invalid Email", htmlFor: "contact-email" },
	            "Email*"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "input-field col s12 m-t-1" },
	          _react2.default.createElement("i", { className: "fa fa-envelope-o prefix", "aria-hidden": "true" }),
	          _react2.default.createElement("textarea", {
	            id: "contact-message",
	            className: "materialize-textarea validate",
	            minLength: "20",
	            name: "message",
	            required: true
	          }),
	          _react2.default.createElement(
	            "label",
	            {
	              htmlFor: "contact-message",
	              "data-error": "Minimum Length is 20 Characters"
	            },
	            "Message*"
	          )
	        ),
	        _react2.default.createElement("div", { className: "col s12 alert-message", id: "contact-alert-message" }),
	        _react2.default.createElement(
	          "div",
	          { className: "col s12" },
	          _react2.default.createElement(
	            "button",
	            {
	              id: "contact-submit",
	              className: "gradient-color waves-effect waves-light",
	              type: "submit"
	            },
	            "Send Message"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "input-field col s12 hidden" },
	          _react2.default.createElement("input", {
	            type: "text",
	            id: "contact-check-spam",
	            placeholder: "Leave field empty",
	            name: "check-spam"
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "address" },
	      _react2.default.createElement(
	        "p",
	        { className: "p-b-1" },
	        _react2.default.createElement("i", { className: "address-icon fa fa-map-marker" }),
	        _react2.default.createElement(
	          "span",
	          null,
	          location
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "p-b-1" },
	        _react2.default.createElement("i", { className: "address-icon fa fa-paper-plane", "aria-hidden": "true" }),
	        _react2.default.createElement(
	          "a",
	          { href: "mailto:" + email },
	          email
	        )
	      )
	    )
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = AboutSection;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function AboutSection(_ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      features = _ref.features;
	
	  return _react2.default.createElement(
	    "section",
	    {
	      id: "about-us",
	      className: "main-section center-align",
	      "data-scroll-index": "7"
	    },
	    _react2.default.createElement(
	      "div",
	      { className: "container" },
	      _react2.default.createElement(
	        "h4",
	        { className: "reflection-text p-b-2" },
	        title
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "p-t-1 desc" },
	        description
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row" },
	        features.map(function (_ref2) {
	          var title = _ref2.title,
	              description = _ref2.description,
	              faIcon = _ref2.faIcon;
	          return _react2.default.createElement(
	            "div",
	            { className: "col s12 l4", key: title },
	            _react2.default.createElement(
	              "div",
	              { className: "icon s6 p-tb-2" },
	              _react2.default.createElement("i", {
	                className: "gradient-color fa fa-" + faIcon + " fa-3x waves-circle waves-effect waves-light"
	              })
	            ),
	            _react2.default.createElement(
	              "h5",
	              { className: "p-tb-1" },
	              title
	            ),
	            _react2.default.createElement(
	              "p",
	              null,
	              description
	            )
	          );
	        })
	      )
	    )
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ContactSection;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ContactSection(_ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      email = _ref.email,
	      facebookLink = _ref.facebookLink;
	
	  return _react2.default.createElement(
	    "section",
	    {
	      id: "contact-section",
	      "data-scroll-index": "8",
	      className: "main-section"
	    },
	    _react2.default.createElement("div", { className: "gradient-color overlay" }),
	    _react2.default.createElement(
	      "div",
	      { className: "container" },
	      _react2.default.createElement(
	        "h4",
	        { className: "reflection-text reflection-text-white p-b-2" },
	        title
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "p-t-1 desc" },
	        description
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "p-t-1 desc" },
	        _react2.default.createElement(
	          "a",
	          { href: "mailto:" + email },
	          email
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "social-icons p-b-1" },
	        _react2.default.createElement(
	          "a",
	          { href: facebookLink, target: "_blank" },
	          _react2.default.createElement("i", { className: "fa fa-facebook shadow-button waves-effect waves-light waves-circle blue" })
	        )
	      )
	    )
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = DownloadSection;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ga = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function DownloadSection(_ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      demoLink = _ref.demoLink,
	      demoQrCode = _ref.demoQrCode,
	      demoImage = _ref.demoImage;
	
	  return _react2.default.createElement(
	    'section',
	    { id: 'download', 'data-scroll-index': '3', className: 'main-section' },
	    _react2.default.createElement('div', { className: 'gradient-color overlay' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'h4',
	        { className: 'reflection-text reflection-text-white p-b-2' },
	        title
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'p-t-1 desc' },
	        description
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row p-t-2' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col s12 l9' },
	          _react2.default.createElement(
	            'a',
	            {
	              href: demoLink,
	              onClick: function onClick() {
	                return (0, _ga.trackEvent)('demo', 'click');
	              },
	              target: '_blank',
	              className: 'm-t-1 grey darken-4 waves-effect waves-light'
	            },
	            _react2.default.createElement(
	              'span',
	              { className: 'big-icon' },
	              _react2.default.createElement('i', { className: 'fa fa-globe' })
	            ),
	            _react2.default.createElement(
	              'span',
	              { className: 'text' },
	              'Try it out'
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            {
	              className: 'waves-effect waves-light',
	              href: demoQrCode,
	              onClick: function onClick() {
	                return (0, _ga.trackEvent)('demo', 'qr');
	              },
	              'data-lity': true
	            },
	            'Scan QR Code'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'col s12 l3 hide-on-med-and-down',
	            'data-aos': 'fade-left',
	            'data-aos-delay': '100'
	          },
	          _react2.default.createElement('img', { className: 'responsive-img', src: demoImage, alt: 'demo-image' })
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = FeaturesSection;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Feature = function Feature(_ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      faIcon = _ref.faIcon,
	      dataId = _ref.dataId,
	      position = _ref.position;
	
	  var icon = _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement("i", {
	      className: "fa fa-" + faIcon + " gradient-color waves-effect waves-light",
	      "aria-hidden": "true"
	    })
	  );
	  return _react2.default.createElement(
	    "div",
	    { className: "single-feature p-tb-2" },
	    _react2.default.createElement(
	      "a",
	      { className: "hoverable feature-link same-height", "data-owl-item": dataId },
	      position === 'right' && icon,
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h5",
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          description
	        )
	      ),
	      position === 'left' && icon
	    )
	  );
	};
	
	function FeaturesSection(_ref2) {
	  var title = _ref2.title,
	      features = _ref2.features;
	
	  return _react2.default.createElement(
	    "section",
	    {
	      id: "features",
	      "data-scroll-index": "1",
	      className: "main-section center-align"
	    },
	    _react2.default.createElement("div", { className: "gradient-color overlay" }),
	    _react2.default.createElement(
	      "div",
	      { className: "container" },
	      _react2.default.createElement(
	        "h4",
	        { className: "reflection-text reflection-text-white p-b-2" },
	        title
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "row p-t-2" },
	        _react2.default.createElement(
	          "div",
	          { className: "col s12 m12 l4 p-tb-1 feature-left" },
	          features.slice(0, 3).map(function (f, i) {
	            return _react2.default.createElement(Feature, _extends({}, f, { dataId: i, key: f.title, position: "left" }));
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col push-m3 push-s3 s6 m6 l4 p-tb-1 images-slider" },
	          _react2.default.createElement(
	            "div",
	            { className: "owl-carousel owl-features" },
	            features.map(function (_ref3) {
	              var title = _ref3.title,
	                  image = _ref3.image;
	              return _react2.default.createElement(
	                "div",
	                { key: title },
	                _react2.default.createElement("img", _extends({ alt: "", className: "responsive-img" }, image))
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col s12 m12 l4 p-tb-1 feature-right" },
	          features.slice(3, 6).map(function (f, i) {
	            return _react2.default.createElement(Feature, _extends({}, f, { dataId: i + 3, key: f.title, position: "right" }));
	          })
	        )
	      )
	    )
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = HeaderSection;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function HeaderSection(_ref) {
	  var bigLogo = _ref.bigLogo,
	      description = _ref.description,
	      findMoreLabel = _ref.findMoreLabel,
	      images = _ref.images;
	
	  return _react2.default.createElement(
	    "header",
	    { id: "main-header", "data-scroll-index": "0" },
	    _react2.default.createElement("div", { className: "overlay gradient-color" }),
	    _react2.default.createElement("div", { id: "particles-js" }),
	    _react2.default.createElement(
	      "div",
	      { className: "header-section container" },
	      _react2.default.createElement(
	        "div",
	        { className: "header-text" },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            "div",
	            { className: "title" },
	            _react2.default.createElement("img", { className: "responsive-img", src: bigLogo, alt: "" })
	          ),
	          _react2.default.createElement(
	            "h4",
	            { className: "description" },
	            description
	          ),
	          _react2.default.createElement(
	            "a",
	            {
	              "data-scroll-goto": "7",
	              className: "slogan z-depth-1 hoverable waves-effect waves-light"
	            },
	            findMoreLabel
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "owl-carousel owl-header" },
	        images.map(function (img) {
	          return _react2.default.createElement("img", _extends({ key: img.alt, alt: "", className: "responsive-img" }, img));
	        })
	      )
	    )
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = PricesContainerSection;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContactForm = __webpack_require__(202);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PricesContainerSection(_ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      formProps = _ref.formProps;
	
	  return _react2.default.createElement(
	    'section',
	    {
	      id: 'prices-contact',
	      'data-scroll-index': '5',
	      className: 'main-section center-align'
	    },
	    _react2.default.createElement(
	      'div',
	      { className: 'main-section' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h4',
	          { className: 'reflection-text p-b-2' },
	          title
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'p-t-1 desc' },
	          description
	        ),
	        _react2.default.createElement(_ContactForm2.default, formProps)
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ScreenshotsSection;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ScreenshotsSection(_ref) {
	  var title = _ref.title,
	      description = _ref.description,
	      screenshots = _ref.screenshots;
	
	  return _react2.default.createElement(
	    "section",
	    {
	      id: "screenshot",
	      "data-scroll-index": "2",
	      className: "main-section center-align"
	    },
	    _react2.default.createElement(
	      "div",
	      { className: "container" },
	      _react2.default.createElement(
	        "h4",
	        { className: "reflection-text p-b-2" },
	        title
	      ),
	      _react2.default.createElement(
	        "p",
	        { className: "p-t-1 desc" },
	        description
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "carousel" },
	        screenshots.map(function (s) {
	          return _react2.default.createElement(
	            "div",
	            { className: "carousel-item", key: s.src },
	            _react2.default.createElement(
	              "a",
	              { href: s.src, "data-lity": true },
	              _react2.default.createElement("img", _extends({ alt: "", className: "responsive-img" }, s))
	            )
	          );
	        })
	      )
	    )
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = SubscribeSection;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function SubscribeSection() {
	  return _react2.default.createElement(
	    "section",
	    { id: "subscribe", className: "main-section center-align" },
	    _react2.default.createElement(
	      "div",
	      { className: "container row", "data-aos": "fade-up", "data-aos-delay": "100" },
	      _react2.default.createElement(
	        "div",
	        { className: "subscribe-container" },
	        _react2.default.createElement(
	          "div",
	          { className: "col s12 l4" },
	          _react2.default.createElement(
	            "h4",
	            { className: "title p-b-2" },
	            "Subscribe"
	          )
	        ),
	        _react2.default.createElement(
	          "form",
	          {
	            id: "subscribe-form",
	            name: "subscribe-form",
	            className: "subscribe-input input-field col s12 l8",
	            "data-netlify": "true"
	          },
	          _react2.default.createElement("input", {
	            name: "subscribe-email",
	            id: "subscribe-email",
	            type: "email",
	            className: "validate"
	          }),
	          _react2.default.createElement(
	            "label",
	            { "data-error": "Invalid Email", htmlFor: "subscribe-email" },
	            "Email"
	          ),
	          _react2.default.createElement(
	            "button",
	            {
	              id: "subscribe-submit",
	              className: "gradient-color waves-effect waves-light",
	              type: "submit"
	            },
	            _react2.default.createElement("i", { className: "fa fa-paper-plane first" }),
	            _react2.default.createElement("i", { className: "fa fa-paper-plane second" })
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "input-field col s12 hidden" },
	            _react2.default.createElement("input", {
	              type: "text",
	              id: "subscribe-check-spam",
	              placeholder: "Leave field empty",
	              name: "check-spam"
	            })
	          )
	        )
	      ),
	      _react2.default.createElement("div", {
	        className: "col s12 alert-message p-t-2",
	        id: "subscribe-alert-message"
	      })
	    )
	  );
	}
	module.exports = exports["default"];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContactSection = __webpack_require__(209);
	
	var _ContactSection2 = _interopRequireDefault(_ContactSection);
	
	var _AboutSection = __webpack_require__(208);
	
	var _AboutSection2 = _interopRequireDefault(_AboutSection);
	
	var _DownloadSection = __webpack_require__(210);
	
	var _DownloadSection2 = _interopRequireDefault(_DownloadSection);
	
	var _FeaturesSection = __webpack_require__(211);
	
	var _FeaturesSection2 = _interopRequireDefault(_FeaturesSection);
	
	var _HeaderSection = __webpack_require__(212);
	
	var _HeaderSection2 = _interopRequireDefault(_HeaderSection);
	
	var _PricesContactSection = __webpack_require__(213);
	
	var _PricesContactSection2 = _interopRequireDefault(_PricesContactSection);
	
	var _ScreenshotsSection = __webpack_require__(214);
	
	var _ScreenshotsSection2 = _interopRequireDefault(_ScreenshotsSection);
	
	var _SubscribeSection = __webpack_require__(215);
	
	var _SubscribeSection2 = _interopRequireDefault(_SubscribeSection);
	
	var _screenshot1Min = __webpack_require__(459);
	
	var _screenshot1Min2 = _interopRequireDefault(_screenshot1Min);
	
	var _screenshot2Min = __webpack_require__(460);
	
	var _screenshot2Min2 = _interopRequireDefault(_screenshot2Min);
	
	var _screenshot3Min = __webpack_require__(461);
	
	var _screenshot3Min2 = _interopRequireDefault(_screenshot3Min);
	
	var _screenshot4Min = __webpack_require__(462);
	
	var _screenshot4Min2 = _interopRequireDefault(_screenshot4Min);
	
	var _screenshot5Min = __webpack_require__(463);
	
	var _screenshot5Min2 = _interopRequireDefault(_screenshot5Min);
	
	var _screenshot6Min = __webpack_require__(464);
	
	var _screenshot6Min2 = _interopRequireDefault(_screenshot6Min);
	
	var _screenshot7Min = __webpack_require__(465);
	
	var _screenshot7Min2 = _interopRequireDefault(_screenshot7Min);
	
	var _logo = __webpack_require__(457);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _qrCodeDemo = __webpack_require__(458);
	
	var _qrCodeDemo2 = _interopRequireDefault(_qrCodeDemo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var scProgram = { src: _screenshot1Min2.default, alt: 'Program' };
	var scMenu = { src: _screenshot2Min2.default, alt: 'Menu' };
	var scDetail = { src: _screenshot3Min2.default, alt: 'Detail' };
	var scNotes = { src: _screenshot4Min2.default, alt: 'Notes' };
	var scChat = { src: _screenshot5Min2.default, alt: 'Chat' };
	var scFeedback = { src: _screenshot6Min2.default, alt: 'Feedback' };
	var scReport = { src: _screenshot7Min2.default, alt: 'Report problem' };
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_HeaderSection2.default, {
	      bigLogo: _logo2.default,
	      description: 'Your number One application for conferences',
	      findMoreLabel: 'Find more about Conf One',
	      images: [scProgram, scMenu, scDetail]
	    }),
	    _react2.default.createElement(_AboutSection2.default, {
	      title: 'About Conf One',
	      description: 'Conf One application allows attendees to view all important information about your conference in the browser as well as an mobile application. Many interactive features will boost their overall positive impression.',
	      features: [{
	        title: 'Super Fast',
	        description: 'Using latest technologies is the application blazing fast and works even offline without internet connection.',
	        faIcon: 'rocket'
	      }, {
	        title: 'Feedback',
	        description: 'Get instant feedback like rating of the presentations or issues in the venue to better organize your event. ',
	        faIcon: 'comments-o'
	      }, {
	        title: 'Feature Rich',
	        description: 'Let your attendees take notes, interact in thematic group chats or navigate through the programme with ease.',
	        faIcon: 'lightbulb-o'
	      }]
	    }),
	    _react2.default.createElement(_FeaturesSection2.default, {
	      title: 'Features',
	      features: [{
	        title: 'Super Fast',
	        description: 'Access all the content without waiting for page to load.',
	        faIcon: 'rocket',
	        image: scProgram
	      }, {
	        title: 'Offline',
	        description: 'All supported browsers allows you to use application without requiring the internet connectivity.',
	        faIcon: 'ban',
	        image: scNotes
	      }, {
	        title: 'Interactive',
	        description: 'Users can see interactive schedule, write their own notes or chat with others',
	        faIcon: 'lightbulb-o',
	        image: scChat
	      }, {
	        title: 'Customizable',
	        description: 'Theme the application to match your brand. Select only the features you want.',
	        faIcon: 'wrench',
	        image: scMenu
	      }, {
	        title: 'Feedback',
	        description: 'Ask your attendees anything, collect feedback or respond to problems immediately when they happen.',
	        faIcon: 'comments-o',
	        image: scFeedback
	      }, {
	        title: 'User Friendly',
	        description: 'Modern responsive design that works on all devices. Seamless installation without requiring heavy app store.',
	        faIcon: 'heartbeat',
	        image: scReport
	      }]
	    }),
	    _react2.default.createElement(_SubscribeSection2.default, null),
	    _react2.default.createElement(_ScreenshotsSection2.default, {
	      title: 'Screenshots',
	      description: 'Get impression about the application look. Of course you can customize it with own content, colors, images and logo.',
	      screenshots: [scProgram, scMenu, scDetail, scNotes, scChat, scFeedback, scReport]
	    }),
	    _react2.default.createElement(_DownloadSection2.default, {
	      title: 'Try it now',
	      description: 'Try out our demo application for the conference \'V\xFDchova k \u017Eivotu 2018.\'',
	      demoLink: 'https://demo.conf.one/',
	      demoImage: _screenshot1Min2.default,
	      demoQrCode: _qrCodeDemo2.default
	    }),
	    _react2.default.createElement(_PricesContactSection2.default, {
	      title: 'Prices',
	      description: 'Please, contact us for getting the price list.',
	      formProps: {
	        name: 'contact-form',
	        id: 'contact-form',
	        location: 'Bratislava, Slovakia',
	        email: 'info@conf-one.com'
	      }
	    }),
	    _react2.default.createElement(_ContactSection2.default, {
	      title: 'Contact us',
	      description: '',
	      email: 'info@conf-one.com',
	      facebookLink: 'https://www.facebook.com/Instea-2058192477758523/?ref=br_rs'
	    })
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.ea46cbfc.png";

/***/ }),

/***/ 458:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/qr-code-demo.873fcafa.jpg";

/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/screenshot1-min.b3ed9b02.png";

/***/ }),

/***/ 460:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/screenshot3-min.1dd0e1f1.png";

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/screenshot5-min.7335199b.png";

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/screenshot6-min.277d5593.png";

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-f1fc8fbb13fcd42de232.js